
<ng-container matColumnDef="date_range_filter">
  <div style="padding: 5px 15px !important;">
    <mat-form-field class="bs-date-range-picker full-width mt-2 mx-3" appearance="outline">
      <mat-label>{{ dateRangeTitle }}</mat-label>
      <input
        type="text"
        matInput
        [appForceReadonly]="true"
        [placeholder]="dateRangePlaceholder"
        [(ngModel)]="date_range"
        name="date_range"
        class="form-control filter-date"
        bsDaterangepicker
        [bsConfig]="datepickerConfig"
        container="body"
        #rangePicker="bsDaterangepicker"
        (onShown)="onDateRangePickerShow()"
        (ngModelChange)="onDateRangePickerChange()"
        [matTooltip]="dateRangeTooltip"
        [errorStateMatcher]="errorStateMatcher"
        id="date_range_input" />
    </mat-form-field>
  </div>
</ng-container>
